<template>
  <div class="">
    <AgentSummary></AgentSummary>
  </div>
</template>

<script setup>
  import AgentSummary from '@/components/Agents/AgentSummary.vue';
</script>
